import { render, staticRenderFns } from "./listRecentNews.vue?vue&type=template&id=40701ade&scoped=true&"
import script from "./listRecentNews.ts?vue&type=script&lang=ts&"
export * from "./listRecentNews.ts?vue&type=script&lang=ts&"
import style0 from "./listRecentNews.vue?vue&type=style&index=0&id=40701ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40701ade",
  null
  
)

export default component.exports